
var _global = typeof self === "undefined" ? global : self
_global.__singleReactRefreshRuntime__ = _global.__singleReactRefreshRuntime__ || require("react-refresh/runtime?fromWrap=1")
module.exports = _global.__singleReactRefreshRuntime__